import { Injectable } from '@angular/core';
import { HandlerService } from '../comunicator-native/handler/handler';
import { CpfModel } from 'src/app/shared/service/cpf/model/cpf.model';
import { CpfDataService } from './cpf-data.service';

@Injectable({
  providedIn: 'root'
})
export class CpfDataMobileService implements CpfDataService{

  constructor(private handlerService: HandlerService) {}

  public getCpf(cpf: string): Promise<CpfModel> {
    const relCaronte = 'aberturaconta-valida-pessoa-fisica';
    const dataCaronte = { cpf: cpf.toString() };
    return this.handlerService.caronteCommunicator(relCaronte, dataCaronte, null).then((data: any) => {
      if (data && data.data) {
        console.log("teste cpf full response", data)
        console.log("teste cpf", data.data)
        return Promise.resolve(data.data);
      } else {
        console.log("caiu no else", data)
        return Promise.resolve();
      }
    });
  }
}

